import { useState } from "react";

const DaysRatiosDropDown = (props) => {

    var options = [{value: '1d', name: '1 Day'},{value: '3d', name: '3 Days'},{value: '7_day', name: '7 Days'},
    {value: '30_day', name: '30 Days'},{value: '60_day', name: '60 Days'},
    {value: '6_month', name: '6 months'},{value: '1_year', name: '1 Year'},
    {value: '2_year', name: '2 Years'},{value: '5_year', name: '5 Years'},
    {value: '10_year', name: '10 Years'},{value: '15_year', name: '15 Years'},
    {value: '20_year', name: '20 Years'}, {value: '30_year', name: '30 Years'},{value: 'all_data', name: 'All Data'},]

    // if currency changed, change the number of days accornigly
    if(props.options) {
        options = props.options
    }

    var val = props.value ? props.value : '3d';

    const [oldValue, setOldValue] = useState(val);

    const fnChange = (e) => {
        setOldValue(e.target.value);
        props.handleChange(e.target.value, oldValue);
    }

    return (
        <select className="form-control days" defaultValue={val}
        onChange={fnChange}>
            {options.map((item,key) => {
                if(!props.chart_name.includes("ratios") && item.value === '3d') 
                    return null
                if(props.value === item.value) 
                    return <option selected value={item.value} key={key}>{item.name}</option>
                return <option value={item.value} key={key}>{item.name}</option>
            })}
        </select>
    )
}

export default DaysRatiosDropDown;